export const UPLOAD_OPTIONS = [
  "createdAt",
  "User",
  "status",
  "description",
  "type",
  "file",
];
